var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 23,
  viewBox: "0 0 32 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 .125)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A90E2",
  d: "M7.122 11a1 1 0 0 0 1.001 1h12.925l-2.873 2.88a.999.999 0 0 0-.002 1.415c.39.39 1.028.382 1.417-.007l4.576-4.576a1.01 1.01 0 0 0 0-1.424L19.59 5.712a1 1 0 0 0-1.417-.007c-.39.39-.387 1.024.002 1.414L21.048 10H8.123a.998.998 0 0 0-1.001 1z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 21,
  x: .5,
  y: .5,
  fillRule: "nonzero",
  stroke: "#4A90E2",
  rx: 2
}))));
export default __webpack_public_path__ + "teg/media/forward-bordered.b8198fa4.svg";
export { SvgComponent as ReactComponent };